import { Command } from 'commander';
import { adminInviteCommand } from './invite.js';
import { adminInvitationsCommand } from './invitations.js';
import { adminRevokeCommand } from './revoke.js';
import { adminMembersCommand } from './members.js';
import { adminMemberRoleCommand } from './member-role.js';
import { adminRemoveCommand } from './remove.js';
import { makeBrainCommand } from '../brain.js';
import { makeTelemetryCommand, makeErrorsCommand } from '../telemetry.js';

// BL598 Phase 1A — the operator commands (brain / telemetry / errors) are
// canonically reached under `gridctl admin <command>`. Each is built from a
// factory so a fresh instance mounts here without colliding with any other
// registration. BL621 Phase 3 (Decision 042 §"Mode 6") moved `hooks` OUT of
// admin to a top-level entity-config group — it is registered in index.ts now.
export const adminCommand = new Command('admin')
  .description('Admin operations on the active grid')
  .addCommand(adminInviteCommand)
  .addCommand(adminInvitationsCommand)
  .addCommand(adminRevokeCommand)
  .addCommand(adminMembersCommand)
  .addCommand(adminMemberRoleCommand)
  .addCommand(adminRemoveCommand)
  .addCommand(makeBrainCommand())
  .addCommand(makeTelemetryCommand())
  .addCommand(makeErrorsCommand());
